import React, { useContext, useEffect, useState } from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import axios from '../../../axios';
import { UserContext } from '../../../UserContext';
import { checkPermiso } from '../../../Utils/PermissionsFunctions';
import Loader from '../../../Layout/Loaders/Loader';
import { BlobProvider } from '@react-pdf/renderer';
import ReporteGlobalPDFDeIngresosXSucursal from '../PDFs/ReporteGlobalPDFDeIngresosXSucursal';

const today = new Date(new Date(new Date().setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString();
const todayEnd = new Date(new Date(new Date().setHours(23, 59, 59, 999)).toString().split('GMT')[0] + ' UTC').toISOString();

const GlobalSucursal = () => {    
    const {user} = useContext(UserContext);
    const [dia,setDia] = useState(new Date());
    const [rango,setRango] = useState({field:'fecha_pedido',start:today,end:todayEnd,sucursal_id:null});
    const [ordenes,setOrdenes] = useState([]);
    const [sucursales,setSucursales] = useState([]);
    const [loader,setLoader] = useState(true);
    const [permisos,setPermisos] = useState({
        orders_read:null,
    });


    useEffect(()=>{
        _getSucursales();
        if(user.id){
            console.log("USer",user);
            setPermisos((prevPremisos) => ({
                ...prevPremisos,
                orders_read:checkPermiso("orders_read",user.permissions)
            })); 
            let sucursal = localStorage.getItem('sucursal_selected');
            if (sucursal !== null) {
                setRango({...rango,sucursal_id:user.sucursal});
            }
           
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[user]);

    useEffect(()=>{
        setLoader(true);
        if(permisos.orders_read) getPedidos();
    },[permisos,rango]);

    const getPedidos = () =>{
        axios.post("/api/global-incomes-report",rango).then((resp)=>{
            console.log("Ordernes",resp);
            let tempData = [];
            if(!user.user_roles.includes("admin")){
                tempData = resp.data.filter(item=>item.empleado === user.name);
            }else tempData = resp.data;
            setOrdenes(tempData);
            setLoader(false);
           // calcularTotales(resp.data);
        }).catch(e=>console.log("Error",e))
    }

    const handleDate = (e) => {
        let date =  new Date(e.target.value);
        date.setDate(date.getDate());
        let nextDate = new Date(e.target.value);
        nextDate.setDate(date.getDate()+1);
        //date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' });
        setDia(nextDate);
        setRango({...rango,start:date,end:nextDate});
    }
    
    const _getSucursales = () =>{
        axios.get('api/sucursals').then((resp)=>{
            setSucursales(resp.data)
        }).catch(e=>console.error("Error ",e));
    }

    const renderSucursalName = () =>{
        let sucursal = sucursales.find(suc=>suc.id == rango.sucursal_id);
        return sucursal ? sucursal.nombre_sucursal : "";
    }


    return (
        <>
            <div className='container-admin-menu'> 
                <Breadcrumb  hasFilters={false} />
            </div> 
            
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1'>
                    <div className='row col s12 info-badge border-r-10 m-p-0 centrar-h' style={{bordeRadius:'10px!important', padding:'0px!important',}}>
                        <div className="col s12 m6 p-0">
                            <h5>Reporte Global de Ingresos por Sucursal - {renderSucursalName()} </h5>
                            <div>Fecha Analisis: {dia.toLocaleDateString("es-MX", { year: 'numeric', month: 'long', day: 'numeric' })} </div>
                        </div>
                        <div className="row col s12 m6 input-text">
                           
                            <div className='col s12 m4 m-p-0 centrar'>
                                {!loader &&
                                    <BlobProvider document={<ReporteGlobalPDFDeIngresosXSucursal ordenes={ordenes} fileName="Reporte_Global_deIngresos_por_Sucursal.pdf" />}>
                                    {({url}) => (
                                        <a className="btn-blanco puntero" style={{marginTop:15}} href={url} target="_blank" rel="noreferrer">
                                            <img className='col s2 m2 m-p-0 dentometric centrar' src='/images/pdf-reporte.png' alt='reporte PDF' style={{width:'20px'}} />
                                            <span className='centrar'> &nbsp;&nbsp;Descargar PDF </span>
                                        </a>
                                    )}
                                    </BlobProvider>
                                }
                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Selecciona una sucursal</label>
                                <select className='browser-default' style={{maxHeight:30}} onChange={(e)=>setRango({...rango,sucursal_id:e.target.value})} value={rango.sucursal_id}>
                                    <option value="" disabled>Selecciona una sucursal</option>
                                    {sucursales.map((suc) =>
                                        <option value={suc.id}  key={suc.id}>{suc.nombre_sucursal}</option>
                                    )}
                                </select>

                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Seleccionar día</label>
                                <input id="dia" type="date" onChange={handleDate}/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="row m-p-0 cont-row">
                            {!loader ? 
                                ordenes.map((orden,index)=>
                                    <div className='col m6 s12 table table-doc row m-t-10 z-depth-1 p-10 border-r-6 centrar' key={index}>
                                        <div class="col m11 s12 container p-10">
                                            <div className='row m-p-0 table-header'>
                                                <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                    {orden.empleado_id}
                                                </div>
                                                <div className='col s12 m10' style={{border:'solid 1px'}}>
                                                    {orden.empleado}
                                                </div>
                                            </div>
                                            <div className='row m-p-0 table-container'>
                                                <div className='row m-p-0' style={{display:'flex'}}>
                                                    <div className='col s12 m2' style={{border:'solid 1px'}}></div>
                                                    <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                        PEDIDOS:
                                                    </div>
                                                    <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                        SUBTOTAL:
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row m-p-0'>
                                                <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                    EFECTIVO
                                                </div>
                                                <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                    {orden.data.efectivo.pedidos}
                                                </div>
                                                <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                    $ {orden.data.efectivo.subTotal}
                                                </div>
                                            </div>
                                            <div className='row m-p-0'>
                                                <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                    TARJETAS
                                                </div>
                                                <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                    {orden.data.credito.pedidos}
                                                </div>
                                                <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                    ${orden.data.credito.subTotal}
                                                </div>
                                            </div>
                                            <div className='row m-p-0'>
                                                <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                    DEBITO
                                                </div>
                                                <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                    {orden.data.debito.pedidos}
                                                </div>
                                                <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                    ${orden.data.debito.subTotal}
                                                </div>
                                            </div>
                                            <div className='row m-p-0'>
                                                <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                    TRANSF
                                                </div>
                                                <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                    {orden.data.transferencia.pedidos}
                                                </div>
                                                <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                    ${orden.data.transferencia.subTotal}
                                                </div>
                                            </div>
                                            <div className='row m-p-0'>
                                                <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                    GASTOS
                                                </div>
                                                <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                    {orden.data.gastos.pedidos}
                                                </div>
                                                <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                    ${orden.data.gastos.subTotal}
                                                </div>
                                            </div>
                                            <div className='row m-p-0 table-container'>
                                                <div className='row m-p-0'>
                                                    <div className='col s12 m10' style={{border:'solid 1px'}}>
                                                        TOTAL DE EFECTIVO
                                                    </div>
                                                    <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                        ${orden.data.totalEfectivo}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row m-p-0'>
                                                <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                    TOTAL
                                                </div>
                                                <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                    {orden.data.pedidosTotal}
                                                </div>
                                                <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                    ${orden.data.total}
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                )
                            :
                            <Loader></Loader>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GlobalSucursal;